import * as types from '../actions/action-types';

const INITIAL_STATE = {
    assignmentOptionsLoading: false,
    assignmentOptions: [],
    assigneeOptions: [],
    assigneeLoading: false,
    showHideAssignedLocation: false,
    assigneeUsername: null,
    assigneeId: null
};

export const getAssignmentOptions = state => state.assignmentOptions;
export const getAssigneeOptions = state => state.assigneeOptions;
export const getAssigneeLoading = state => state.assigneeLoading;
export const getShowHideAssignedLocation = state =>
    state.showHideAssignedLocation;
export const getAssigneeUsername = state => state.assigneeUsername;
export const getAssigneeId = state => state.assigneeId;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.ASSIGNMENT_OPTIONS) {
        return {
            ...state,
            assignmentOptions: action.payload
        };
    }
    if (action.type === types.ASSIGNEE_OPTIONS) {
        return {
            ...state,
            assigneeOptions: action.payload
        };
    } else if (action.type === types.SHOW_HIDE_ASSIGNED_LOCATION) {
        return {
            ...state,
            showHideAssignedLocation: !state.showHideAssignedLocation
        };
    } else if (action.type === types.HIDE_ASSIGNED_LOCATION) {
        return {
            ...state,
            showHideAssignedLocation: false
        };
    } else if (action.type === types.ASSIGNEE_LOADING) {
        return {
            ...state,
            assigneeLoading: !state.assigneeLoading,
            assigneeOptions: []
        };
    } else if (action.type === types.ASSIGNEE_USERNAME_SUCCESS) {
        return {
            ...state,
            assigneeUsername: action.username,
            assigneeId: action.usernameId
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/assigned-location.js